<dl class="placeholder-list">
  <dt>{{ 'market_discovery.questionnaire.question.available_placeholders.text' | translate }}</dt>
  <dd>{{ 'market_discovery.questionnaire.question.placeholder_user_name.label' | translate }}</dd>
  <dd>{{ 'market_discovery.questionnaire.question.placeholder_company_name.label' | translate }}</dd>
  <dd>{{ 'market_discovery.questionnaire.question.placeholder_customer_company_name.label' | translate }}</dd>
  <dd>{{ 'market_discovery.questionnaire.question.placeholder_contact_name.label' | translate }}</dd>
</dl>
